import React, { useCallback } from 'react';
import NotificacoesMain from './Listagem/index';

const Notificacoes = () => {
  return <NotificacoesMain />;
};

export default Notificacoes;
